export enum CollectionNotice {
    YesWithoutReminderFee,
    YesWithReminderFee,
    No
}